import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=dcf35350&scoped=true&"
import script from "./order-table.ts?vue&type=script&lang=ts&"
export * from "./order-table.ts?vue&type=script&lang=ts&"
import style0 from "./order-table.scss?vue&type=style&index=0&id=dcf35350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf35350",
  null
  
)

export default component.exports